// extracted by mini-css-extract-plugin
export default {"theme-btn":"ToggleTheme_theme-btn__Ll4t3"};